<template>
  <Doughnut
    :chart-options="chartOptions"
    :chart-data="chartData"
    :chart-id="chartId"
    :dataset-id-key="datasetIdKey"
    :plugins="plugins"
    :css-classes="cssClasses"
    :styles="styles"
    :width="width"
    :height="height"
  />
</template>

<script>
import { Doughnut } from "vue-chartjs/legacy";

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  CategoryScale,
} from "chart.js";

ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale);

export default {
  name: "DoughnutChart",

  components: {
    Doughnut,
  },

  props: {
    campaignData: {
      type: Array,
    },
    chartId: {
      type: String,

      default: "doughnut-chart",
    },

    datasetIdKey: {
      type: String,

      default: "label",
    },

    width: {
      type: Number,

      default: 250,
    },

    height: {
      type: Number,

      default: 250,
    },

    cssClasses: {
      default: "",

      type: String,
    },

    styles: {
      type: Object,

      default: () => {},
    },

    plugins: {
      type: Array,

      default: () => [],
    },
  },

  data() {
    return {
      // chartData: {
      //   datasets: [
      //     {
      //       backgroundColor: ["#d3008c", "#d1d1d1"],
      //       // backgroundColor: ["#ac12a2", "#d3008c", "#ff90d8", "#d1d1d1"],

      //       data: [],
      //       // data: [40, 20, 80],
      //     },
      //   ],
      // },
      chartData: {
        // labels: ["VueJs", "EmberJs", "ReactJs", "AngularJs"],

        datasets: [
          {
            backgroundColor: ["#ac12a2", "#d3008c", "#ff90d8", "#d1d1d1"],

            data: [40, 20, 80, 10],
          },
        ],
      },

      chartOptions: {
        responsive: true,

        maintainAspectRatio: false,
      },
    };
  },
  methods: {},
  mounted() {
    this.chartData.datasets[0].data = this.campaignData;
    // console.log("campaignData props : ", this.chartData.datasets[0].data);
  },
};
</script>
